<template>
  <div>
    <v-row>
      <v-col cols="12" md="6">
        <div class="mt-10 d-flex justify-space-between heading-2">
          <span>
            Exams and Credentials for {{ GetPreviewUser.FirstName }}
            {{ GetPreviewUser.LastName }}
          </span>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <v-card flat class="d-flex justify-end mt-2">
          <div class="d-flex justify-end mt-10">
            <!-- <template v-slot:activator="{ on, attrs }" class="px-10"> -->
            <div class="d-flex justify-end">
              <v-btn
                rounded
                outlined
                color="#1884CD"
                class=""
                dark
                style="
                  text-transform: none !important;
                  border: 1px solid #d2e5fc;
                "
                @click="ExamsPaymentDialog = true"
                >Add Payment</v-btn
              >
              <!-- v-bind="attrs"
                v-on="on" -->
            </div>
            <!-- </template> -->
            <v-dialog v-model="ExamsPaymentDialog" width="650" persistent>
              <v-card class="px-6 pt-8 pb-4" v-if="ExamsPaymentDialog">
                <div>
                  <ExamCredentialPaymentComponent
                    :ExamCredentialPaymentProcess="ExamsPaymentDialog"
                    :examName="examName"
                    :credentialName="credentialName"
                    @close="close"
                  />
                </div>
              </v-card>
            </v-dialog>
            <v-btn
              rounded
              outlined
              color="#1884CD"
              class="ml-4"
              dark
              style="text-transform: none !important; border: 1px solid #d2e5fc"
              @click="openadddialog()"
              >Add Exam/Credential</v-btn
            >
            <v-dialog v-model="add_dialog" persistent max-width="500">
              <v-card v-if="add_dialog">
                <add-exam
                  :add_dialog="add_dialog"
                  @close="close"
                  @update="close"
                />
              </v-card>
            </v-dialog>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <div>
      <v-card class="mt-6" outlined>
        <v-data-table
          :headers="examsheaders"
          :loading="btnloader"
          :items="getUserExams"
          loading-text="Loading... Please wait"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:[`item.ExamDate`]="{ item }">
            <span class="index_span_2_style">
              {{ item.ExamDate.split("T")[0].replaceAll("-", "/") }}
            </span>
          </template>
          <!-- <template v-slot:[`item.exam`]="{ item }">
            <span class="index_span_2_style">
              {{ item.exam }}
            </span>
          </template>
          <template v-slot:[`item.instructor`]="{ item }">
            <span class="index_span_2_style">
              {{ item.instructor }}
            </span>
          </template>
          <template v-slot:[`item.downlaods`]>
            <v-icon color="#A1A1A6" class="pa-4"> mdi-download </v-icon>
          </template> -->
          <template v-slot:[`item.Credential`]="{ item }">
            <span class="index_span_2_style">
              {{ getCrendialName(item.Credential) }}
            </span>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-icon block @click="editExam(item)"> mdi-pencil </v-icon>
            <v-icon color="#A1A1A6" class="pa-2" @click="openDeleteDialog(item.Id)">
              mdi-delete
            </v-icon>
            <v-dialog v-model="deletedialog" persistent max-width="290">
              <v-card>
                <v-card-title class="text-h5">Warning</v-card-title>
                <v-card-text class="index_span_2_style"
                  >Are you sure you want to delete?</v-card-text
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-1" text @click="closeDeleteDialog">
                    Cancel
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="btnloader"
                    @click="deleteExam(selectedExamId)"
                  >
                    <span v-if="btnloader != true" >Confirm</span>
                    <v-progress-circular
                      indeterminate
                      v-else
                      size="20"
                      class="px-5"
                      color="white"
                      v-show="btnloader"
                    ></v-progress-circular>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <v-dialog v-model="editexam" persistent max-width="500">
      <v-card v-if="editexam">
        <div>
          <EditExam
            :editexam="editexam"
            @close="close"
            :editExamData="examData"
          />
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AddExam from "../add-exam.vue";
import EditExam from "../Edit-exam.vue";
import ExamCredentialPaymentComponent from "../../../components/Users/paymentcomponents/ExamsCredentialPayment.componet.vue";

export default {
  components: {
    AddExam,
    EditExam,
    ExamCredentialPaymentComponent,
  },
  computed: {
    ...mapGetters(["GetPreviewUser", "getUserExams"]),
  },
  mounted() {
    if (this.GetPreviewUser == null) {
      this.$router.push("/users");
    }
    this.fetchData();
  },

  name: "seeprofilecomponent",
  data() {
    return {
      deletedialog:false,
      selectedExamId: null,
      ExamsPaymentDialog: false,
      CEUsearch: "",
      shippingAddressRadio: "",
      ClinicCheckbox: false,
      HomeCheckbox: false,
      publiclyRadio: "",
      editAddressdialog: false,
      invoicedialog: false,
      Membereditdialog: false,
      editexam: false,
      editdialog: false,
      billingeditdialog: false,
      addreseditdialog: false,
      btnloader: false,
      btnloader1: false,
      add_dialog: false,
      examData: null,

      examsheaders: [
        { text: "Date", value: "ExamDate", sortable: false },
        { text: "Exam", value: "ExamName", sortable: false },
        { text: "Instructor", value: "InstructorName", sortable: false },
        { text: "Written Score", value: "WrittenScore", sortable: false },
        { text: "Practical Score ", value: "PracticalScore", sortable: false },

        { text: " Credential ", value: "Credential", sortable: false },
        // { text: "Certificate", value: "downlaods", sortable: false },
        { text: "", value: "actions", sortable: false },
      ],
      examsDataTable: [
        {
          date: "08/13/2022",
          exam: " CBP",
          instructor: "",
          politicalscore: "56",
          credential: "AdvCBP",
        },
        {
          date: "08/13/2022",
          exam: " CBP",
          instructor: "",
          politicalscore: "56",
          credential: "AdvCBP",
        },
      ],
      chk: "calle 142,1480,Breaztegui 1448, Areis",
      chk2: "calle 142,1480,Breaztegui 1448, Areis",
      CEUHours: [
        {
          userName: "Miranda jamieson",
          startDate: "04 Jul, 2011 ",
          endDate: "04 Jul, 2013",
        },
      ],
      item: {
        Membership: "Practitioners",
        Frequency: "Anually",
        Amount: "$99/Year",
        DateMemberShip: "11/11/2021-11/11/2022",
        Data6: "3",
        Data7: "15",
      },
      object: {
        UsertName: "Axel",
        FirstName: "Axel",
        LastName: "Camelitti",
        PhoneNumber: "+11 3333432",
        dateRegistered: "11/11/2021",
      },
      object1: {
        Data6: "3",
        Data: "15",
      },
      items: [
        {
          icon: "<v-icon>mdi-truck</v-icon>",
          avatar: "https://picsum.photos/250/300?image=660",
          name: '<span style="font-weight: 700;font-size: 30px;">Alex Camelatti</span> ',
          email: `<span style="color: rgba(34, 34, 34, 0.65);">alex@gmail.com</span> `,
        },
      ],

      tabs: null,
      examName: "",
      credentialName: "",
      CredentialsArray: [
        { name: "CBP", id: 1 },
        { name: "CBP-A", id: 2 },
        { name: "AdvCBP", id: 3 },
        { name: "PaRama CBP", id: 4 },
        // { name: "Adv_CBP 4(7) & 9", id: 5 },
        // { name: "Adv_CBP 3 & 6", id: 6 }
      ],
    };
  },
  methods: {
    getCrendialName(number) {
      switch (number) {
        case 1:
          return "CBP";
        case 2:
          return "CBP-A";
        case 3:
          return "AdvCBP";
        case 4:
          return "PaRama CBP";
      }
    },
    fetchData() {
      this.btnloader = true;
      const obj = {
        id: this.GetPreviewUser.Id,
      };
      this.$store.dispatch("GetUserExams", obj).then(() => {
        this.examName = "";
        this.credentialName = "";
        this.examName = this.getUserExams
          .map((item) => item.ExamName)
          .join(", ");
        this.credentialName = this.getUserExams
          .map((item) => {
            const credential = this.CredentialsArray.find(
              (cred) => cred.id === item.Credential
            );
            return credential ? credential.name : ""; // Return the name if found, otherwise an empty string
          })
          .filter((name) => name !== "")
          .join(", ");
        this.btnloader = false;
      });
    },
    editExam(data) {
      this.editexam = true;
      this.examData = data;
    },
    openDeleteDialog(examId) {
      this.selectedExamId = examId;
      this.deletedialog = true;
    },
    closeDeleteDialog() {
      this.deletedialog = false;
      this.selectedExamId = null; // Reset selected exam
    },
    deleteExam(id) {
      this.btnloader = true;
      this.$store.dispatch("DeleteUserExamById", id).then(() => {
        this.$swal({
          position: "top-end",
          icon: "success",
          title: "Delete Exam successfully",
          showConfirmButton: false,
          timer: 1500,
          toast: true,
        });
        this.fetchData();
        this.deletedialog = false;
        this.btnloader = false;
      });
    },
    close() {
      this.editdialog = false;
      this.editexam = false;
      this.addreseditdialog = false;
      this.add_dialog = false;
      this.snackbar = true;
      this.ExamsPaymentDialog = false;
      this.fetchData();
    },
    closeDialog() {
      this.add_dialog = false;
      this.value = false;
    },
    DdialogClose() {
      this.dialog = false;
      this.Deletesnackbar = true;
    },
    snackbarClose() {
      // this.snackbar = false;
      this.Deletesnackbar = false;
    },
    openadddialog() {
      this.add_dialog = true;
    },
    send() {
      setTimeout(() => {
        this.btnloader = true;
      }, 100);
      setTimeout(() => {
        this.add_dialog = false;
        this.editdialog = false;
        this.editexam = false;
        this.addreseditdialog = false;
        this.addreseditdialog = false;
        this.Membereditdialog = false;
        this.billingeditdialog = false;
        this.Memberinfoeditdialog = false;
        this.editAddressdialog = false;
        this.btnloader = false;
      }, 2000);
    },
  },
};
</script>
<style scoped></style>
